import { useMemo } from "react";

import { IAttribute } from "@interfaces/attribute.interface";

import { filterAttributesForDeal } from "../utils";
import { useAllAttributes } from "./useCompanyAttributes";

/** Attributes applicable to a deal. */
export function useDealAttributes() {
  const { data: attributes, ...rest } = useAllAttributes();

  const data = useMemo<IAttribute[]>(
    () => (attributes ? filterAttributesForDeal(attributes) : []),
    [attributes]
  );

  return { data, ...rest };
}
